import { render } from "./MenuSection.vue?vue&type=template&id=24c5875c"
import script from "./MenuSection.vue?vue&type=script&lang=js"
export * from "./MenuSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/nginx/domains/tools.androidrepublic.org/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MenuSection.vue"]])

export default __exports__